var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeophyte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10578 4.34308L8.67147 4.46423L8.98581 3.97856C10.4007 1.79246 13.5993 1.79246 15.0142 3.97856L15.3285 4.46423L15.8942 4.34308C18.4405 3.79775 20.7022 6.0595 20.1569 8.60578L20.0358 9.17147L20.5214 9.48581C22.7075 10.9007 22.7075 14.0993 20.5214 15.5142L20.0358 15.8285L20.1569 16.3942C20.7022 18.9405 18.4405 21.2022 15.8942 20.6569L15.3285 20.5358L15.0142 21.0214C13.5993 23.2075 10.4007 23.2075 8.98581 21.0214L8.67147 20.5358L8.10578 20.6569C5.5595 21.2022 3.29775 18.9405 3.84308 16.3942L3.96423 15.8285L3.47856 15.5142C1.29246 14.0993 1.29246 10.9007 3.47856 9.48581L3.96423 9.17147L3.84308 8.60578C3.29775 6.0595 5.5595 3.79775 8.10578 4.34308Z",
    stroke: "#EBD2B7",
    strokeWidth: 1.67797
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 2,
    fill: "#EBD2B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeophyte);
export default __webpack_public_path__ + "static/media/neophyte.16c446d768a479ca4fd48d2b494cca27.svg";
export { ForwardRef as ReactComponent };